import z from 'zod';
import { caseIdValue } from '../../case/value-objects/ids';
import { editorLawTypeValue } from '../../shared/lawTypesContants';
import { firmIdValue, userIdValue, } from '../../subscription/value-objects/ids';
import { editorDraftIdValue, libraryDocumentIdValue, } from '../value-objects/ids';
export const editorDraftVariableValuesSchema = z.record(z.string(), z.string());
export const editorDraftSchema = z.object({
    caseId: caseIdValue,
    editorHtml: z.string(),
    firmId: firmIdValue,
    id: editorDraftIdValue,
    isCorporateIdentityApplied: z.boolean(),
    lawType: editorLawTypeValue,
    libraryDocumentId: libraryDocumentIdValue,
    updatedAt: z.date(),
    userId: userIdValue,
    variableValues: editorDraftVariableValuesSchema,
});
export const parseEditorDraft = (value) => editorDraftSchema.parse(value);
export const isEditorDraft = (value) => editorDraftSchema.safeParse(value).success;
//# sourceMappingURL=editor-draft.js.map